module.exports = __webpack_public_path__ + "img/slider2.10f46fc2.jpg";